module.exports = __webpack_public_path__ + "img/893163f8e0d35abd2d3a949ea6564d94.db747497.webp";